import React from 'react';
import { Compass } from 'lucide-react';

import { hollowIconDefaults, iconSize } from '../../../util/iconSettings';

const CUSTOM_LINK_ICONS = {
  discover: Compass,
};

const CustomLinkIcon = props => {
  const { name, className, size = iconSize.menuItem } = props;
  const Icon = CUSTOM_LINK_ICONS[name];

  return Icon ? (
    <Icon
      className={className}
      size={size}
      {...hollowIconDefaults}
      aria-hidden="true"
      data-testid={`custom-link-icon-${name}`}
    />
  ) : null;
};

export default CustomLinkIcon;
